import {
  Box,
  Button,
  Typography,
  useMediaQuery,
  List,
  ListItem,
} from "@mui/material";
import Sidebar from "./CourseSidebar";
import color from "../../../../components/utils/Colors";
import React from "react";
import TestVideoSteps from "./TestVideoSteps";

const CourseVideoTest = () => {
  const isSmallScreen = useMediaQuery("(max-width:900px)");

  const [open, setOpen] = React.useState(false);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };
  return (
    <Box
      sx={{
        display: "flex",
        height: "auto",
        margin: isSmallScreen ? "10px" : "30px",
        marginTop: "0px",
        paddingTop: isSmallScreen ? "5px" : "30px",
        gap: "1%",
        marginBottom: "0px",
        paddingBottom: "5%",
        borderRadius: "10px",
        flexDirection: isSmallScreen ? "column" : "row",
      }}
    >
      <Sidebar />

      <Box
        sx={{
          marginTop: isSmallScreen ? "25px" : "0px",
          flex: 1,
          pl: "3%",
          borderRadius: "16px",
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: 3,
          }}
        >
          <Typography
            variant="h5"
            gutterBottom
            sx={{
              background: color.textColor,
              textAlign: "center",
              color: "white",
              width: "fit-content",
              margin: "auto",
              padding: "2px 10px",
              borderRadius: "4px",
              mb: 0,
            }}
          >
            Test Video
          </Typography>

          <Typography
            sx={{
              color: color.textColor,
              ml: 1,
              fontSize: "20px",
              fontWeight: "bold",
              mb: 0,
              textAlign: "center",
              width: "100%",
            }}
          >
            Free expert video help
          </Typography>

          <Typography
            sx={{
              color: color.textColor,
              ml: 1,
              fontSize: "16px",
              fontWeight: "bold",
              mb: -1,
              textAlign: "center",
              width: "100%",
            }}
          >
            Get personalized advice on your audio and video
          </Typography>

          <Typography
            sx={{
              color: color.textColor,
              ml: 1,
              fontSize: "20px",
              fontWeight: "bold",
              mb: -1,
              textAlign: "start",
              width: "100%",
            }}
          >
            Test video step:
          </Typography>

          <div
            style={{
              padding: "10px",
              width: "100%",
              paddingTop: 0,
              marginTop: "-10px",
              color: color.textColor,
              textAlign: "left",
            }}
          >
            <List>
              <ListItem>
                <Typography variant="body1">
                  • Tell us which language will be spoken in your video
                </Typography>
              </ListItem>
              <ListItem>
                <Typography variant="body1">
                  • Optimize your area and equipment
                </Typography>
              </ListItem>
              <ListItem>
                <Typography variant="body1">
                  • Ensure students can see, hear, and understand you
                </Typography>
              </ListItem>
              <ListItem>
                <Typography variant="body1">
                  • Record a test of 1-3 minutes
                </Typography>
              </ListItem>
              <ListItem>
                <Typography variant="body1">
                  • Submit as many as you want
                </Typography>
              </ListItem>
            </List>
          </div>

          <Button onClick={handleOpen} id="button" sx={{ margin: "auto" }}>
            Create test video
          </Button>
          <TestVideoSteps open={open} handleClose={handleClose} />

        </Box>
      </Box>
    </Box>
  );
};

export default CourseVideoTest;
